import { render, staticRenderFns } from "./Zhuce.vue?vue&type=template&id=1d65a2db&scoped=true"
import script from "./Zhuce.vue?vue&type=script&lang=js"
export * from "./Zhuce.vue?vue&type=script&lang=js"
import style0 from "./Zhuce.vue?vue&type=style&index=0&id=1d65a2db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d65a2db",
  null
  
)

export default component.exports